var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 50,
    viewBox: "0 0 40 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 2.51398V11.514C24.5 12.7075 24.9741 13.852 25.818 14.696C26.6619 15.5399 27.8065 16.014 29 16.014H38M15.5 18.264H11M29 27.264H11M29 36.264H11M26.75 2.51398H6.5C5.30653 2.51398 4.16193 2.98808 3.31802 3.832C2.47411 4.67591 2 5.8205 2 7.01398V43.014C2 44.2075 2.47411 45.352 3.31802 46.196C4.16193 47.0399 5.30653 47.514 6.5 47.514H33.5C34.6935 47.514 35.8381 47.0399 36.682 46.196C37.5259 45.352 38 44.2075 38 43.014V13.764L26.75 2.51398Z",
    stroke: "#08387C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDr);
export default __webpack_public_path__ + "static/media/dr.1c5eba7b978a6d76152e93f3739de50e.svg";
export { ForwardRef as ReactComponent };